module.exports = __webpack_public_path__ + "img/status.6024d34b.svg";